export default "__VITE_ASSET__DoD40i1V__"